module.exports = [{"data":"c120","title":"c120"},{"data":"c140","title":"c140"},{"data":"c160","title":"c160"},{"data":"c161","title":"c161"},{"data":"c180","title":"c180"},{"data":"c181","title":"c181"},{"data":"c182","title":"c182"},{"data":"c183","title":"c183"},{"data":"c200","title":"c200"},{"data":"iv","title":"iv"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/fatty-acid-raw-variable.json
// module id = 1DQz
// module chunks = 102